import { IwocaLogo } from '@iwoca/orion';

import QontoConnect from './assets/QontoConnect.svg';
import QontoLogo from './assets/QontoLogo.svg';
import styles from './Qonto.module.css';

export const Qonto = () => {
  const onClick = () => {
    window.location.href = '/api/qonto/connect/';
  };

  return (
    <div>
      <div className={styles.navBar}>
        <IwocaLogo className={styles.logo} />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <img
            className={styles.connectLogo}
            src={QontoConnect}
            alt="Connect Qonto to iwoca"
          />
          <h1 className={styles.header}>
            Verbinde deinen Qonto-Account, um deine Kreditanfrage zu starten
          </h1>
          <p>
            Spare Zeit und verbinde dich mit Qonto, um in wenigen Schritten
            herauszufinden, ob du einen Kredit erhalten kannst.
          </p>
          <button className={styles.qontoButton} onClick={onClick}>
            <img
              className={styles.buttonLogo}
              src={QontoLogo}
              alt="Qonto logo"
            />
            Mit Qonto verbinden
          </button>
          <p className={styles.terms}>
            Indem du fortfährst, erlaubst du iwoca Deutschland GmbH den Zugriff
            auf deine Qonto-Daten und akzeptierst unsere{' '}
            <a href="https://www.iwoca.de/compliance/allgemeine-geschaeftsbedingungen">
              AGB
            </a>
          </p>
          <p className={styles.loginContainer}>
            Einen bestehenden Antrag fortsetzen -
            <a className={styles.login} href="/login/">
              hier anmelden
            </a>
          </p>
          <a href="https://app.qonto.com/deeplinks?action=financing">Zurück</a>
        </div>
      </div>
    </div>
  );
};
